import { render } from "./UserAchievementsCard.vue?vue&type=template&id=401d56bf"
import script from "./UserAchievementsCard.vue?vue&type=script&lang=js"
export * from "./UserAchievementsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__